export const MESSAGE = {
  PAYMENT_FAILED:
    "Payment Failed: We hit a tiny turbulence. Re-aligning your path 🛫",
};

export const WEB_LINK = {
  BECOME_MEMBER: "https://www.sabehub.com/the-foundry/application",
  SABE_LOCATION: "https://maps.app.goo.gl/w8UYDMukdZC7LZdE9",
  WHATSAPP_CHANNEL: "https://chat.whatsapp.com/EHsB5pOZ2mMIA5Kufmb1uN",
  TERM_CONDITION:
    "https://www.sabehub.com/termsandconditions",
  PRIVACY_POLICY:
    "https://sabehub.com/cancellation-refunds-wallet-policy.html",
  ABOUT_US: "https://www.sabehub.com/about",
  CLEAN_FUEL_CAFE: "https://www.sabehub.com/cafe/tf",
  THE_FOUNDRY_DETAIL: " https://sabehub.com/the-foundry/application",
  ENERY_SPACE: "https://sabehub.com/energy",
  WELNESS_LINK: "https://sabehub.com/wellness",
  WORKSPACE_APP: "https://workspace.sabehub.com",
  SABEHUB_LINK: "https://www.sabehub.com",
  THE_FOUNDRY_URL: "https://sabehub.com/the-foundry",
  CONNECT_LINK: "https://chat.whatsapp.com/EHsB5pOZ2mMIA5Kufmb1uN",
  FOCUS_HOUSE_LANDING_LINK: "https://sabehub.com/experiences/focus-house",
  EXECUTION_SPACE_LINK: "https://www.sabehub.com/execution/apply"
};

export const STRING = {
  APP_EXIT_POPUP_TITLE: "Switching Spaces",
  APP_EXIT_POPUP_MESSAGE:
    "You’re about to get redirected to an external link. Do you want to go ahead?",
  APP_EXIT_POPUP_BUTTON: "Yes, let’s go",
  CANCEL_RESERVATION_POPUP_TITLE: "Are you serious ?",
  CANCEL_RESERVATION_POPUP_MESSAGE:
    "Are you sure you want to cancel this reservation?",
  CANCEL_RESERVATION_POPUP_BUTTON: "Yes",
  MEMBERSHIP_EXPIRE_INFO_TITLE: "Membership Expiry Alert",
  MEMBERSHIP_EXPIRE_INFO_SUB_TITLE:
    "You can book events only until Membership validity date. Please renew your membership to continue booking beyond this date.",
  MEMBERSHIP_EXPIRE_INFO_BUTTON_TITLE: "View Plans",
  FOUNDER_ONLY_POPUP_TITLE: "Founder Only Event",
  FOUNDER_ONLY_POPUP_SUB_TITLE:
    "Oops! This is a Founder Only Event . If you have not marked yourself as a Founder, contact the Sabehub Team to attend the event !",
  FOUNDER_ONLY_POPUP_BUTTON_TITLE: "Contact Sabehub",
};

export const IMAGE_LINK = {
  COMMUNICATE_SPACE:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/communicate-space-image.png",
  COMMUNICATE_SPACE_1:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/communicate-space-image-1.png",
  COMMUNICATE_SPACE_2:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/communicate-space-image-2.png",
  CREATIVE_SPACE:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/creative-space-image.png",
  CREATIVE_SPACE_1:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/creative-space-image-1.png",
  CREATIVE_SPACE_2:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/creative-space-image-2.png",
  INNOVATIVE_SPACE:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/innovative-space-image.png",
  INNOVATIVE_SPACE_1:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/innovative-space-image-1.png",
  INNOVATIVE_SPACE_2:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/innovative-space-image-2.png",
  INNOVATIVE_SPACE_3:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/innovative-space-image-3.png",
  INNOVATIVE_SPACE_4:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/innovative-space-image-4.png",
  EXPERIENCES:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/foundry-experiences-final.png",
  SCALING_WORKSHOPS:
    "https://sabe-public-documents.s3.ap-south-1.amazonaws.com/images/foundry-scaling-workshops.png",
};
